export interface OtherAmountRow {
  id: string;
  amount: number;
  currency: string;
  exchangeRate?: number;
  chequeDate?: string;
  chequeNumber?: string;
  bankName?: string;
  /** Encoded account: "bank:<documentId>" or "safe:<documentId>" */
  depositAccount?: string;
}

export interface InTransactionFormData {
  invoiceId: string;
  amount: number;
  currency: string;
  exchangeRate?: number;
  amountCollectedCurrency: string;
  amountCollectedRate?: number;
  chequeDate?: string;
  chequeNumber?: string;
  bankName?: string;
  /** Encoded account: "bank:<documentId>" or "safe:<documentId>" */
  depositAccount?: string;
  deductionAmount?: number;
  deductionCurrency?: string;
  deductionRate?: number;
  notes?: string;
  transactionDate?: string;
}

/**
 * Convert an amount into the invoice's currency using a rate-to-EGP.
 * EGP -> foreign invoice: divide; foreign -> EGP invoice: multiply.
 */
export const convertToInvoiceCurrency = (
  amount: number,
  fromCode: string,
  invoiceCode: string,
  rate?: number
): number => {
  if (!amount) return 0;
  if (!invoiceCode || !fromCode || fromCode === invoiceCode) return amount;
  if (!rate || rate <= 0) return 0;
  if (fromCode === 'EGP' && invoiceCode !== 'EGP') return amount / rate;
  if (fromCode !== 'EGP' && invoiceCode === 'EGP') return amount * rate;
  return amount;
};

export interface DropdownOption {
  value: string;
  label: string;
}

/** Split an encoded deposit account value into its type and documentId */
export const parseDepositAccount = (
  value?: string
): { type: 'bank' | 'safe'; id: string } | null => {
  if (!value) return null;
  const [type, id] = value.split(':');
  if ((type === 'bank' || type === 'safe') && id) return { type, id };
  return null;
};

/** Build a readable label for an invoice option: number + value */
export const formatInvoiceLabel = (inv: any, currencyCode: string): string => {
  const number = inv?.invoiceNumber || `#${inv?.id}`;
  const total = Number(inv?.netTotal ?? inv?.total ?? 0).toLocaleString();
  const customer = inv?.customer?.name ? ` — ${inv.customer.name}` : '';
  return `${number}${customer} — ${currencyCode} ${total}`;
};
